import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const fadeInUp = {
  hidden: { opacity: 0, y: 40 },
  visible: (i = 1) => ({
    opacity: 1,
    y: 0,
    transition: {
      delay: i * 0.15,
      duration: 0.6,
      ease: 'easeOut',
    },
  }),
};

const Aboutus = () => {
  const navigate = useNavigate();
  return (
     <div className="min-h-screen bg-white pb-20 px-4 md:px-8 text-blue-900 pt-48 font-lato">
      <div className="max-w-5xl mx-auto relative">
 {/* Back Arrow */}
        <button
          onClick={() => navigate(-1)}
          className="absolute left-0 -top-10 flex items-center text-blue-700 hover:text-blue-900 transition-colors"
        >
          <ArrowLeft className="h-6 w-6 mr-2" />
          Back
        </button>

        <motion.h1
          className="text-5xl font-extrabold text-center mb-10 bg-gradient-to-r from-blue-700 via-purple-600 to-pink-500 text-transparent bg-clip-text"
          initial="hidden"
          animate="visible"
          variants={fadeInUp}
        >
          About Us
        </motion.h1>

        <motion.p className="text-xl font-medium text-center mb-12"
          custom={1}
          initial="hidden"
          animate="visible"
          variants={fadeInUp}
        >
          ✨ Welcome to <span className="font-bold">THE GREAT HIMALAYAS</span> – Where nature meets tech, and journeys become magic.
        </motion.p>

        {/* Sections */}
        {[
          {
            title: 'Our Story',
            content: `Founded by IIT Madras alumni and adventurers, THE GREAT HIMALAYAS emerged from soul-searching treks and wild travel dreams. It's a platform born on trails and perfected with tech.`,
          },
          {
            title: 'What We Offer',
            content: (
              <ul className="list-disc pl-6 space-y-2">
                <li><strong>Hotels:</strong> Boutique stays soaked in local culture, food & folklore 🌄</li>
                <li><strong>Cabs:</strong> Route-based pricing with real-time web bookings 🚕</li>
                <li><strong>Web App:</strong> Your trip planning AI companion — all-in-one 🧭</li>
              </ul>
            ),
          },
          {
            title: 'Our Mission',
            content: `To turn your travels into therapy. Escape, explore, and evolve. We create journeys that ground your soul, not just fill your camera roll.`,
          },
          {
            title: 'Why Us?',
            content: (
              <ul className="list-disc pl-6 space-y-2">
                <li>🎓 Backed by IIT minds</li>
                <li>🧳 Designed by passionate travelers</li>
                <li>🌿 Committed to eco-tourism & communities</li>
                <li>🌀 For wanderers, by wanderers – Travel is our therapy</li>
              </ul>
            ),
          },
          {
            title: 'Join the Journey',
            content: `Whether it’s Dzongu’s hidden trails or a silent retreat in Pelling, let us build your Himalayan fairytale. Chill. Trek. Connect. Repeat. 🌍🧘‍♀️🍵`,
          },
        ].map((section, index) => (
          <motion.div
            key={section.title}
            className="mb-10"
            custom={index + 2}
            initial="hidden"
            animate="visible"
            variants={fadeInUp}
          >
            <h2 className="text-3xl font-semibold mb-4">{section.title}</h2>
            <div className="text-base leading-relaxed">{section.content}</div>
          </motion.div>
        ))}

        <motion.p
          className="text-center mt-16 text-xl font-bold"
          custom={7}
          initial="hidden"
          animate="visible"
          variants={fadeInUp}
        >
          🚀 Let us help you travel better. Let us help you travel deeper.
        </motion.p>
      </div>
    </div>
  );
};

export default Aboutus;
